import { StyleSheet } from 'aphrodite';

import { CampaignsDisplay } from '../CampaignsDisplay';

export class CampaignsDisplayAdvertiser extends CampaignsDisplay {

  constructor(props) {
    super(props, {pageForOrgType: 'ADVERTISER'})
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/advertisers/CampaignsDisplayAdvertiser.js